export enum Filters {
  search = "search",
  industry = "industry",
  sortBy = "sortBy",
  country = "country",
  page = "page",
}
